import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { z } from 'zod';

import { createAccountAtom } from '@/services/globalState';

export const createAccountSchema = z.object({
  email: z.string().min(1, 'Email address is required').email('Invalid email address'),
  referredBy: z.string().optional(),
});

export type CreateAccount = z.infer<typeof createAccountSchema>;

/**
 * Hook for managing create account flow state across steps
 *
 * Provides centralized state management for the multi-step account creation process,
 * allowing data to persist between steps and be reset when needed.
 *
 * Persists referral code from URL parameters to ensure it survives navigation between steps.
 */
export function useCreateAccount() {
  const [data, setData] = useAtom(createAccountAtom);

  const reset = useResetAtom(createAccountAtom);

  return {
    data,
    setData,
    reset,
  };
}
